import { ProductDetailsMainContainer } from '@/modules/Products';

const ProductsDetails = (): JSX.Element => <ProductDetailsMainContainer />;

export default ProductsDetails;
